"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scope = void 0;

var _session = require("./session.js");

var _is = require("./utils-hoist/is.js");

var _logger = require("./utils-hoist/logger.js");

var _misc = require("./utils-hoist/misc.js");

var _propagationContext = require("./utils-hoist/propagationContext.js");

var _time = require("./utils-hoist/time.js");

var _merge = require("./utils/merge.js");

var _spanOnScope = require("./utils/spanOnScope.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */

class ScopeClass {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called during event processing. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */

  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */

  /** Session */

  /** Request Mode Session Status */
  // eslint-disable-next-line deprecation/deprecation

  /** The client on this scope */

  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = {
      traceId: (0, _propagationContext.generateTraceId)(),
      spanId: (0, _propagationContext.generateSpanId)()
    };
  }
  /**
   * @inheritDoc
   */


  clone() {
    const newScope = new ScopeClass();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = _objectSpread({}, this._tags);
    newScope._extra = _objectSpread({}, this._extra);
    newScope._contexts = _objectSpread({}, this._contexts);

    if (this._contexts.flags) {
      // We need to copy the `values` array so insertions on a cloned scope
      // won't affect the original array.
      newScope._contexts.flags = {
        values: [...this._contexts.flags.values]
      };
    }

    newScope._user = this._user;
    newScope._level = this._level;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = _objectSpread({}, this._sdkProcessingMetadata);
    newScope._propagationContext = _objectSpread({}, this._propagationContext);
    newScope._client = this._client;
    newScope._lastEventId = this._lastEventId;
    (0, _spanOnScope._setSpanForScope)(newScope, (0, _spanOnScope._getSpanForScope)(this));
    return newScope;
  }
  /**
   * @inheritDoc
   */


  setClient(client) {
    this._client = client;
  }
  /**
   * @inheritDoc
   */


  setLastEventId(lastEventId) {
    this._lastEventId = lastEventId;
  }
  /**
   * @inheritDoc
   */


  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */


  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */


  addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }
  /**
   * @inheritDoc
   */


  addEventProcessor(callback) {
    this._eventProcessors.push(callback);

    return this;
  }
  /**
   * @inheritDoc
   */


  setUser(user) {
    // If null is passed we want to unset everything, but still define keys,
    // so that later down in the pipeline any existing values are cleared.
    this._user = user || {
      email: undefined,
      id: undefined,
      ip_address: undefined,
      username: undefined
    };

    if (this._session) {
      (0, _session.updateSession)(this._session, {
        user
      });
    }

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation


  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation


  setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }
  /**
   * @inheritDoc
   */


  setTags(tags) {
    this._tags = _objectSpread(_objectSpread({}, this._tags), tags);

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setTag(key, value) {
    this._tags = _objectSpread(_objectSpread({}, this._tags), {}, {
      [key]: value
    });

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setExtras(extras) {
    this._extra = _objectSpread(_objectSpread({}, this._extra), extras);

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setExtra(key, extra) {
    this._extra = _objectSpread(_objectSpread({}, this._extra), {}, {
      [key]: extra
    });

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setLevel(level) {
    this._level = level;

    this._notifyScopeListeners();

    return this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */


  setTransactionName(name) {
    this._transactionName = name;

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */


  update(captureContext) {
    if (!captureContext) {
      return this;
    }

    const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;

    const _ref = scopeToMerge instanceof Scope ? // eslint-disable-next-line deprecation/deprecation
    [scopeToMerge.getScopeData(), scopeToMerge.getRequestSession()] : (0, _is.isPlainObject)(scopeToMerge) ? [captureContext, captureContext.requestSession] : [],
          _ref2 = _slicedToArray(_ref, 2),
          scopeInstance = _ref2[0],
          requestSession = _ref2[1];

    const _ref3 = scopeInstance || {},
          tags = _ref3.tags,
          extra = _ref3.extra,
          user = _ref3.user,
          contexts = _ref3.contexts,
          level = _ref3.level,
          _ref3$fingerprint = _ref3.fingerprint,
          fingerprint = _ref3$fingerprint === void 0 ? [] : _ref3$fingerprint,
          propagationContext = _ref3.propagationContext;

    this._tags = _objectSpread(_objectSpread({}, this._tags), tags);
    this._extra = _objectSpread(_objectSpread({}, this._extra), extra);
    this._contexts = _objectSpread(_objectSpread({}, this._contexts), contexts);

    if (user && Object.keys(user).length) {
      this._user = user;
    }

    if (level) {
      this._level = level;
    }

    if (fingerprint.length) {
      this._fingerprint = fingerprint;
    }

    if (propagationContext) {
      this._propagationContext = propagationContext;
    }

    if (requestSession) {
      this._requestSession = requestSession;
    }

    return this;
  }
  /**
   * @inheritDoc
   */


  clear() {
    // client is not cleared here on purpose!
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._session = undefined;
    (0, _spanOnScope._setSpanForScope)(this, undefined);
    this._attachments = [];
    this.setPropagationContext({
      traceId: (0, _propagationContext.generateTraceId)()
    });

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS; // No data has been changed, so don't notify scope listeners

    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = _objectSpread({
      timestamp: (0, _time.dateTimestampInSeconds)()
    }, breadcrumb);

    this._breadcrumbs.push(mergedBreadcrumb);

    if (this._breadcrumbs.length > maxCrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);

      if (this._client) {
        this._client.recordDroppedEvent('buffer_overflow', 'log_item');
      }
    }

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */


  clearBreadcrumbs() {
    this._breadcrumbs = [];

    this._notifyScopeListeners();

    return this;
  }
  /**
   * @inheritDoc
   */


  addAttachment(attachment) {
    this._attachments.push(attachment);

    return this;
  }
  /**
   * @inheritDoc
   */


  clearAttachments() {
    this._attachments = [];
    return this;
  }
  /** @inheritDoc */


  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: (0, _spanOnScope._getSpanForScope)(this)
    };
  }
  /**
   * @inheritDoc
   */


  setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = (0, _merge.merge)(this._sdkProcessingMetadata, newData, 2);
    return this;
  }
  /**
   * @inheritDoc
   */


  setPropagationContext(context) {
    this._propagationContext = _objectSpread({
      // eslint-disable-next-line deprecation/deprecation
      spanId: (0, _propagationContext.generateSpanId)()
    }, context);
    return this;
  }
  /**
   * @inheritDoc
   */


  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */


  captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0, _misc.uuid4)();

    if (!this._client) {
      _logger.logger.warn('No client configured on scope - will not capture exception!');

      return eventId;
    }

    const syntheticException = new Error('Sentry syntheticException');

    this._client.captureException(exception, _objectSpread(_objectSpread({
      originalException: exception,
      syntheticException
    }, hint), {}, {
      event_id: eventId
    }), this);

    return eventId;
  }
  /**
   * @inheritDoc
   */


  captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0, _misc.uuid4)();

    if (!this._client) {
      _logger.logger.warn('No client configured on scope - will not capture message!');

      return eventId;
    }

    const syntheticException = new Error(message);

    this._client.captureMessage(message, level, _objectSpread(_objectSpread({
      originalException: message,
      syntheticException
    }, hint), {}, {
      event_id: eventId
    }), this);

    return eventId;
  }
  /**
   * @inheritDoc
   */


  captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0, _misc.uuid4)();

    if (!this._client) {
      _logger.logger.warn('No client configured on scope - will not capture event!');

      return eventId;
    }

    this._client.captureEvent(event, _objectSpread(_objectSpread({}, hint), {}, {
      event_id: eventId
    }), this);

    return eventId;
  }
  /**
   * This will be called on every set call.
   */


  _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;

      this._scopeListeners.forEach(callback => {
        callback(this);
      });

      this._notifyingListeners = false;
    }
  }

}
/**
 * Holds additional event information.
 */


const Scope = exports.Scope = ScopeClass;
/**
 * Holds additional event information.
 */